import { apiService } from 'services/axiosHandler';

const path = 'users';

export const getUserRequest = async (params = undefined, selfRole = undefined) => {
    let headers;
    if(selfRole){
        headers = {
            'x-sipekad-self-role': selfRole
        }
    }
    
    const req = await apiService.get(`/${path}`, { 
        params,
        headers
    });

    if (req.status !== 200) {
        throw req.data.message || req.statusText || req
    }

    return req.data;
};

export const addUserRequest = async (payload, selfRole = undefined) => {
    let headers;
    if(selfRole){
        headers = {
            'x-sipekad-self-role': selfRole
        }
    }
    
    const req = await apiService.post(`/${path}`, payload, { headers });

    if (req.status !== 201) {
        throw req.data.message || req.statusText || req
    }

    return req.data;
};
  
export const updateUserRequest = async (id, payload, selfRole = undefined) => {
    let headers;
    if(selfRole){
        headers = {
            'x-sipekad-self-role': selfRole
        }
    }

    const req = await apiService.patch(`/${path}/${id}`, payload, { headers });

    if (req.status !== 200) {
        throw req.data.message || req.statusText || req
    }

    return req.data;
};
  
export const deleteUserRequest = async (id, selfRole = undefined) => {
    let headers;
    if(selfRole){
        headers = {
            'x-sipekad-self-role': selfRole
        }
    }

    const req = await apiService.delete(`/${path}/${id}`, { headers });

    if (req.status !== 204) {
        throw req.data.message || req.statusText || req
    }

    return req.data;
};

export const getUserPermissionRequest = async (params = undefined) => {    
    const req = await apiService.get(`/${path}`, { 
        params,
    });

    if (req.status !== 200) {
        throw req.data.message || req.statusText || req
    }

    return req.data;
};
  
export const restoreUserDefaultPermissionsRequest = async (id) => {
    const req = await apiService.post(`/${path}/${id}/restore-default-permissions`);

    if (req.status !== 200) {
        throw req.data.message || req.statusText || req
    }

    return req.data;
};

export const generatePasswordlessTokenRequest = async (id) => {

    const req = await apiService.post(`/${path}/${id}/passwordless-token`, {
        target_platform: 'app'
    });

    if (req.status !== 200) {
        throw req.data.message || req.statusText || req
    }

    return req.data;
};